import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { NavItem } from 'react-bootstrap';

import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import GDPRPage from './GDPRPage';
import SAMLPage from './SAMLPage';
import InvitationExclusionPage from './InvitationExclusionPage';
import MicrosoftDynamicsPage from './MicrosoftDynamicsPage';
import SyncNotificationPage from './SyncNotificationPage';
import ImportPage from './ImportPage';

import SalesGoalsPage from './SalesGoalsPage';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';

function OrganizationPage(props) {
  const { location: { pathname }, organization } = props;
  const synced = organization && organization.organization_id !== null && organization.organization_id !== undefined;

  const isDemo = organization && organization.is_demo;
  const isAzure = organization && organization.type === 'azure';

  return (
    <div>
      <Helmet title="Organization Setup" />
      <div className="container">
        <ul className="nav nav-tabs">
          <LinkContainer to="/setup/organization/sync-notification">
            <NavItem>Sync Notification</NavItem>
          </LinkContainer>
          <LinkContainer to="/setup/organization/gdpr-compliance">
            <NavItem>GDPR Compliance</NavItem>
          </LinkContainer>
          {synced &&
            <LinkContainer to="/setup/organization/new-users">
              <NavItem>New Users</NavItem>
            </LinkContainer>
          }
          <LinkContainer to="/setup/organization/saml">
            <NavItem>SAML</NavItem>
          </LinkContainer>
          <LinkContainer to="/setup/organization/sales-goals">
            <NavItem>Sales Settings</NavItem>
          </LinkContainer>
          {isAzure &&
            <LinkContainer to="/setup/organization/dynamics">
              <NavItem>Microsoft Dynamics</NavItem>
            </LinkContainer>
          }
          <LinkContainer to="/setup/organization/import">
            <NavItem>Import Data</NavItem>
          </LinkContainer>
        </ul>
        <p />
      </div>
      <Switch>
        <Route path="/setup/organization/sync-notification" component={SyncNotificationPage} />
        <Route path="/setup/organization/gdpr-compliance" component={GDPRPage} />
        <Route path="/setup/organization/saml" component={SAMLPage} />
        <Route path="/setup/organization/sales-goals" component={SalesGoalsPage} />
        <Route path="/setup/organization/import" component={ImportPage} />
        {isAzure && <Route path="/setup/organization/dynamics" component={MicrosoftDynamicsPage} />}
        {synced && <Route path="/setup/organization/new-users" component={() => <InvitationExclusionPage organization={organization} />} />}
        {(pathname === '/setup/organization' && <Redirect to="/setup/organization/gdpr-compliance" />)}
      </Switch>
    </div>
  );
}


// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    organization: getUserCurrentOrganization(state),
  };
}

OrganizationPage.propTypes = {
  location: PropTypes.shape({}).isRequired,
  organization: PropTypes.shape({
    is_demo: PropTypes.bool,
    type: PropTypes.string,
  }).isRequired,
};

OrganizationPage.contextTypes = {
  router: PropTypes.object,
};

export default withRouter(connect(mapStateToProps)(OrganizationPage));
